import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
import styled from "@emotion/styled";

const StyledDataGridCell = styled("div")({
  "&.test-columnHeader": {
    zIndex: 2,
    position: "sticky",
    right: 0,
    background: "white",
  },
  "&.test-cell": {
    zIndex: 1,
    position: "sticky",
    right: 0,
    background: "white",
  },
});

type ActionsCellProps = {
  onEdit?: () => void;
  onDelete?: () => void;
};

const ActionsCell: React.FC<ActionsCellProps> = ({ onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledDataGridCell>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {onEdit && (
          <MenuItem
            onClick={(event) => {
              onEdit();
              handleClose();
            }}
          >
            Edit
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem
            onClick={(event) => {
              onDelete();
              handleClose();
            }}
          >
            Delete
          </MenuItem>
        )}
      </Menu>
    </StyledDataGridCell>
  );
};
export default ActionsCell;
